import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import {
  GridRowModes,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

function EditToolbar(props) {
  const { setCompaniesData, setRowModesModel, isAdmin } = props;
  let navigate = useNavigate();

  const handleAddClick = () => {
    const id = 0;
    setCompaniesData((oldRows) => [
      ...oldRows,
      {
        id,
        companyName: "",
        street: "",
        regionId: 0,
        zip: "",
        iban: "",
        bic: "",
        accountName: "",
        taxNumber: "",
        tel: "",
        isNew: true,
      },
    ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "companyName" },
    }));
  };

  function handleRefresh() {
    navigate(0);
  }

  return (
    <GridToolbarContainer>
      <Button
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddClick}
        disabled={!isAdmin}
      >
        Neu
      </Button>

      <GridToolbarColumnsButton />
      <GridToolbarFilterButton field="companyName" />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        csvOptions={{
          fileName: "Firmendaten",
          delimiter: ";",
          utf8WithBom: true,
        }}
      />

      <GridToolbarQuickFilter />
      <Button color="primary" startIcon={<SyncIcon />} onClick={handleRefresh}>
        Refresh
      </Button>
    </GridToolbarContainer>
  );
}

EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
  setCompaniesData: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

export default EditToolbar;